import router from "./router";
import store from "./store";
import iView from "iview";
import {
	menusToRoutes
} from "./utils";
// 这只是简单示范 建议结合cookie或token使用

const menuOrigin = {
	// menuItems: [
	//   {
	//     name: "home", // 要跳转的路由名称 不是路径
	//     size: 18, // icon大小
	//     type: "md-home", // icon类型
	//     text: "主页" // 文本内容
	//   },
	//   {
	//     text: "生产管理",
	//     type: "ios-paper",
	//     children: [
	//       {
	//         type: "ios-grid",
	//         name: "meter_regist",
	//         text: "设备批量注册"
	//       },
	//       {
	//         type: "ios-paper",
	//         name: "meter_reset",
	//         text: "设备批量重置"
	//       },
	//       {
	//         type: "ios-grid",
	//         name: "meter_export",
	//         text: "基表信息导出"
	//       },
	//       {
	//         type: "ios-grid",
	//         name: "up_instructions_menu",
	//         text: "查询上传指令"
	//       },
	//       {
	//         type: "ios-grid",
	//         name: "down_instructions_menu",
	//         text: "查询下发指令"
	//       },
	//       {
	//         type: "ios-grid",
	//         name: "instructions_detailed_produce",
	//         text: "设备交互(生产)"
	//       }
	//     ]
	//   }
	// ],

	//左侧菜单栏数据
	menuItems: [{
			name: "home", // 要跳转的路由名称 不是路径
			size: 18, // icon大小
			type: "md-home", // icon类型
			text: "主页", // 文本内容
		},
		{
			text: "燃气公司信息管理",
			type: "ios-at",
			children: [{
					type: "ios-paper",
					name: "governing_body_menu",
					text: "管辖机构信息",
				},
				{
					type: "ios-paper",
					name: "personnel_body_menu",
					text: "员工信息",
				},
				{
					type: "ios-paper",
					name: "wx_debind",
					text: "微信解绑",
				},
				{
					type: "ios-paper",
					name: "import_meter_history",
					text: "设备导入及查看",
				},
			],
		},
		{
			text: "用户信息管理",
			type: "ios-contact",
			children: [{
					type: "ios-paper",
					name: "address_menu",
					text: "地址信息",
				},
				{
					type: "ios-paper",
					name: "meter_menu",
					text: "表具信息",
				},
				{
					type: "ios-paper",
					name: "customer_gas_application",
					text: "用户燃气用具",
				},
			],
		},
		{
			text: "数据查询",
			type: "ios-construct",
			children: [{
					type: "ios-paper",
					name: "daily_use_record",
					text: "使用记录",
				},
				{
					type: "ios-paper",
					name: "pipe_environment_params",
					text: "管道环境参数",
				},
				{
					type: "ios-paper",
					name: "meter_state",
					text: "设备状态",
				},
				{
					type: "ios-paper",
					name: "metering_data",
					text: "计量数据",
				},
				{
					type: "ios-paper",
					name: "valve_state",
					text: "开关阀记录",
				},
				{
					name: "data_info", // 要跳转的路由名称 不是路径
					type: "ios-notifications", // icon类型
					text: "数据统计", // 文本内容
				},
			],
		},
		{
			text: "家用燃气控制阀",
			type: "ios-construct",
			children: [{
					type: "ios-paper",
					name: "valve_manage",
					text: "产品导入",
				},
				{
					type: "ios-paper",
					name: "valve_upinstructions_3",
					text: "参数设置測試版",
				},
				{
					type: "ios-paper",
					name: "valve_upinstructions_2",
					text: "参数设置",
				},
				{
					type: "ios-paper",
					name: "valvenb_upinstructions_2",
					text: "参数设置NB",
				},
				{
					type: "ios-paper",
					name: "valve_collection",
					text: "数据采集",
				},
				{
					type: "ios-paper",
					name: "valve_collection_2",
					text: "NB数据采集",
				},
				{
					type: "ios-paper",
					name: "valve_regular_upload",
					text: "日运行数据",
				},
				{
					type: "ios-paper",
					name: "valve_reboot",
					text: "重启记录",
				},
				{
					type: "ios-paper",
					name: "valve_operation",
					text: "使用记录",
				},
				{
					type: "ios-paper",
					name: "valvenb_operation",
					text: "使用记录NB",
				}
			]
		},
		// {
		// 	text: "家用燃气控制阀NB",
		// 	type: "ios-construct",
		// 	children: [
		// 		{
		// 			type: "ios-paper",
		// 			name: "valve_nb_manage",
		// 			text: "产品导入",
		// 		},
		// 		{
		// 			type: "ios-paper",
		// 			name: "valvenb_upinstructions_2",
		// 			text: "参数设置",
		// 		}
		// 	]
		// },
		{
			text: "家用智能燃气表",
			type: "ios-construct",
			children: [
				{
					type: "ios-paper",
					name: "company_manage",
					text: "公司管理",
				},
				{
					type: "ios-paper",
					name: "staff_manage",
					text: "员工管理",
				},
				{
					type: "ios-paper",
					name: "valuation_manage",
					text: "计价方案管理",
				},
				{
					type: "ios-paper",
					name: "address_manage",
					text: "地址管理",
				},
				{
					type: "ios-paper",
					name: "customer_manage",
					text: "户主管理",
				},
				{
					type: "ios-paper",
					name: "meter_base_manage",
					text: "基表管理",
				},
				{
					type: "ios-paper",
					name: "meter_box_manage",
					text: "智能盒管理",
				},
				{
					type: "ios-paper",
					name: "meter_alarm_bind_manage",
					text: "报警器绑定管理",
				},
				{
					type: "ios-paper",
					name: "meter_box_down",
					text: "参数设置",
				},
				{
					type: "ios-paper",
					name: "meter_work_info",
					text: "运行记录",
				},
				{
					type: "ios-paper",
					name: "meter_alarm_info",
					text: "报警记录",
				},
				{
					type: "ios-paper",
					name: "meter_alarm_alarm_info",
					text: "报警器报警记录",
				},
			]
		},
		{
			text: "家用智能报警器",
			type: "ios-construct",
			children: [
				{
					type: "ios-paper",
					name: "alarm_manage",
					text: "报警器管理",
				},
				{
					type: "ios-paper",
					name: "alarm_Off_Manage",
					text: "立即关阀",
				},
				{
					type: "ios-paper",
					name: "alarm_Condition_Threshold",
					text: "标定条件阈值",
				},
				{
					type: "ios-paper",
					name: "alarm_Leakage_Manage",
					text: "泄露报警阈值",
				},
				{
					type: "ios-paper",
					name: "alarm_Sensor_Manage",
					text: "传感器故障阈值",
				},
				{
					type: "ios-paper",
					name: "AlarmNB_LeakCheck",
					text: "泄露阈值",
				},
				{
					type: "ios-paper",
					name: "alarm_Server_Manage",
					text: "服务器配置",
				},
				{
					type: "ios-paper",
					name: "alarm_Heartbeat_Manage",
					text: "心跳间隔时间",
				},	
				{
					type: "ios-paper",
					name: "alarm_Resetting",
					text: "传感器使用时长重置",
				},	
				{
					type: "ios-paper",
					name: "alarm_down",
					text: "参数设置(楼栋)",
				},
				{
					type: "ios-paper",
					name: "alarm_downNBandWIFI",
					text: "参数设置",
				},
				{
					type: "ios-paper",
					name: "alarm_work_info",
					text: "日用气量(楼栋)",
				},
				{
					type: "ios-paper",
					name: "alarm_Daily_Data",
					text: "运行数据",
				},
				{
					type: "ios-paper",
					name: "meter_NBalarm_upload_info",
					text: "NB报警器上传记录",
				},
				{
					type: "ios-paper",
					name: "meter_NBalarm_download_info",
					text: "NB报警器下发记录",
				},
				{
					type: "ios-paper",
					name: "meter_alarm_upload_info",
					text: "报警器上传记录",
				},
				{
					type: "ios-paper",
					name: "meter_alarm_download_info",
					text: "报警器下发记录",
				},
				{
					type: "ios-paper",
					name: "alarm_Record",
					text: "报警记录",
				},
				{
					type: "ios-paper",
					name: "alarm_Record_Building",
					text: "报警记录(楼栋)",
				},
				{
					type: "ios-paper",
					name: "regulatory",
					text: "监管部门",
				},
			]
		},
		{
			text: "报警信息查询",
			type: "ios-paper",
			children: [{
					type: "ios-paper",
					name: "valve_alarm",
					text: "报警信息",
				},
				{
					type: "ios-paper",
					name: "valvenb_alarm",
					text: "泄漏类报警NB",
				},
				{
					type: "ios-paper",
					name: "valve_alarm2",
					text: "温压异常类报警",
				},
				{
					type: "ios-paper",
					name: "valve_alarm3",
					text: "欠费类报警",
				},
				{
					type: "ios-paper",
					name: "valve_alarm4",
					text: "设备故障类报警",
				},
				{
					type: "ios-paper",
					name: "valve_alarm5",
					text: "设备失联",
				},
			]
		},
		{
			text: "设备交互",
			type: "ios-construct",
			children: [{
					type: "ios-paper",
					name: "up_instructions_menu",
					text: "查询上传指令",
				},
				// {
				//   type: "ios-paper",
				//   name: "valve_upinstructions",
				//   text: "安全阀测试",
				// },  
				{
					type: "ios-paper",
					name: "down_instructions_menu",
					text: "查询下发指令",
				},
				{
					type: "ios-paper",
					name: "instructions_detailed_menu",
					text: "设备交互",
				},
				// {
				//     type: "ios-paper",
				//     name: "daily_use_record",
				//     text: "使用记录"
				// },
				// {
				//   type: "ios-paper",
				//   name: "daily_use_record",
				//   text: "使用记录",
				// },
				{
					type: "ios-paper",
					name: "instructions_detailed_for_list",
					text: "设备交互(批量)",
				},
				{
					type: "ios-paper",
					name: "instructions_ladder_for_list",
					text: "下发阶梯气价(批量)",
				},
			],
		},
		{
			text: "设备维护",
			type: "ios-hammer",
			children: [{
					type: "ios-paper",
					name: "open_account",
					text: "设备开户",
				},
				{
					type: "ios-paper",
					name: "recharge",
					text: "充值",
				},
				{
					type: "ios-paper",
					name: "order_create",
					text: "工单维护",
				},
				{
					type: "ios-paper",
					name: "order_list",
					text: "工单记录",
				},
				{
					type: "ios-paper",
					name: "abnormal_detailed",
					text: "异常监控",
				},
				{
					type: "ios-paper",
					name: "ladderPrice",
					text: "阶梯气价",
				},
			],
		},
		{
			text: "设置管理",
			type: "ios-settings",
			children: [{
					type: "ios-paper",
					name: "meter_type",
					text: "表具类型",
				},
				{
					type: "ios-paper",
					name: "gastype",
					text: "用气类型",
				},
				{
					type: "ios-paper",
					name: "gas_appliances",
					text: "燃气用具",
				},
				{
					type: "ios-paper",
					name: "set_up_repair_list",
					text: "维修故障设置",
				},
				{
					type: "ios-paper",
					name: "push_exception_config",
					text: "报警推送配置",
				},
				{
					type: "ios-paper",
					name: "dictionary_manufacturer",
					text: "设备厂家",
				},
				{
					type: "ios-paper",
					name: "dictionary_specifications",
					text: "表规格",
				},
			],
		},
		{
			text: "信息发布",
			type: "ios-notifications",
			children: [{
					type: "ios-paper",
					name: "push_msg",
					text: "消息发布",
				},
				{
					type: "ios-paper",
					name: "record_msg",
					text: "消息记录",
				},
				{
					type: "ios-paper",
					name: "customer_response",
					text: "用户反馈",
				},
			],
		},
		{
			text: "图表展示",
			type: "ios-apps",
			children: [{
					type: "ios-paper",
					name: "eCharts_exception",
					text: "报警图例",
				},
				{
					type: "ios-paper",
					name: "eCharts_sales",
					text: "营业额图例",
				},
				{
					type: "ios-paper",
					name: "eCharts_flow",
					text: "用气量图例",
				},
				{
					type: "ios-paper",
					name: "pipeline",
					text: "管道泄漏",
				},
				{
					type: "ios-paper",
					name: "eChart_test",
					text: "测试图例",
				},
			],
		},
		{
			text: "权限管理",
			type: "logo-buffer",
			children: [{
				type: "ios-paper",
				name: "managep_permission",
				text: "权限管理",
			}, ],
		},
		{
			text: "通讯管理",
			type: "logo-buffer",
			children: [{
					type: "ios-paper",
					name: "registe_profile",
					text: "注册配置文件",
				},
				{
					type: "ios-paper",
					name: "manage_down_queue",
					text: "管理下发队列",
				},
			],
		},
		{
			text: "阀门模块",
			type: "ios-folder",
			children: [{
				type: "ios-paper",
				name: "profile",
				text: "设备交互",
			}, ],
		},
		{
			text: "生产管理",
			type: "ios-cube",
			children: [{
					type: "ios-paper",
					name: "meter_regist",
					text: "设备批量注册",
				},
				{
					type: "ios-paper",
					name: "meter_reset",
					text: "设备批量重置",
				},
				{
					type: "ios-paper",
					name: "meter_export",
					text: "基表信息导出",
				},

				// {
				//   type: "ios-paper",
				//   name: "up_instructions_menu",
				//   text: "查询上传指令",
				// },
				// {
				//   type: "ios-paper",
				//   name: "down_instructions_menu",
				//   text: "查询下发指令",
				// },
				{
					type: "ios-paper",
					name: "instructions_detailed_produce",
					text: "设备交互(生产)",
				},
			],
		},
	],
	// menuItems: [
	//     {
	//         name: "home", // 要跳转的路由名称 不是路径
	//         size: 18, // icon大小
	//         type: "md-home", // icon类型
	//         text: "主页" // 文本内容
	//     },
	//     {
	//         text: "基础信息",
	//         type: "ios-paper",
	//         children: [
	//             {
	//                 type: "ios-grid",
	//                 name: "address_menu",
	//                 text: "地址信息"
	//             },
	//             {
	//                 type: "ios-grid",
	//                 name: "governing_body_menu",
	//                 text: "管辖机构信息"
	//             },
	//             {
	//                 type: "ios-grid",
	//                 name: "personnel_body_menu",
	//                 text: "员工信息"
	//             },
	//             {
	//                 type: "ios-grid",
	//                 name: "meter_menu",
	//                 text: "表具信息"
	//             },
	//             {
	//                 type: "ios-grid",
	//                 name: "meter_type",
	//                 text: "表具类型"
	//             },
	//             {
	//                 type: "ios-grid",
	//                 name: "import_file",
	//                 text: "基础信息导入"
	//             },
	//             {
	//                 type: "ios-grid",
	//                 name: "ladderPrice",
	//                 text: "阶梯气价"
	//             },
	//             {
	//                 type: "ios-grid",
	//                 name: "gastype",
	//                 text: "用气类型"
	//             }
	//         ]
	//     },
	//     {
	//         text: "设备交互",
	//         type: "ios-paper",
	//         children: [
	//             {
	//                 type: "ios-grid",
	//                 name: "up_instructions_menu",
	//                 text: "查询上传指令"
	//             },
	//             {
	//                 type: "ios-grid",
	//                 name: "down_instructions_menu",
	//                 text: "查询下发指令"
	//             },
	//             {
	//                 type: "ios-grid",
	//                 name: "instructions_detailed_menu",
	//                 text: "设备交互"
	//             }
	//         ]
	//     },
	//     {
	//         text: "设备维护",
	//         type: "ios-paper",
	//         children: [
	//             {
	//                 type: "ios-grid",
	//                 name: "open_account",
	//                 text: "设备开户"
	//             },
	//             {
	//                 type: "ios-grid",
	//                 name: "recharge",
	//                 text: "充值"
	//             },
	//             {
	//                 type: "ios-grid",
	//                 name: "order_create",
	//                 text: "工单维护"
	//             },
	//             {
	//                 type: "ios-grid",
	//                 name: "abnormal_detailed",
	//                 text: "异常监控"
	//             },
	//             {
	//                 type: "ios-grid",
	//                 name: "push_msg",
	//                 text: "消息发布"
	//             },
	//             {
	//                 type: "ios-grid",
	//                 name: "record_msg",
	//                 text: "消息记录"
	//             },
	//             {
	//                 type: "ios-grid",
	//                 name: "set_up_repair_list",
	//                 text: "报警开关"
	//             },
	//             {
	//                 type: "ios-grid",
	//                 name: "push_exception_config",
	//                 text: "报警推送配置"
	//             },
	//             {
	//                 type: "ios-grid",
	//                 name: "customer_response",
	//                 text: "用户反馈"
	//             },
	//             {
	//                 type: "ios-grid",
	//                 name: "gas_appliances",
	//                 text: "燃气用具"
	//             },
	//             {
	//                 type: "ios-grid",
	//                 name: "customer_gas_application",
	//                 text: "用户燃气用具"
	//             }
	//         ]
	//     },
	//     {
	//         text: "图表展示",
	//         type: "ios-paper",
	//         children: [
	//             {
	//                 type: "ios-grid",
	//                 name: "eCharts_exception",
	//                 text: "报警图例"
	//             },
	//             {
	//                 type: "ios-grid",
	//                 name: "eCharts_sales",
	//                 text: "营业额图例"
	//             },
	//             {
	//                 type: "ios-grid",
	//                 name: "eCharts_flow",
	//                 text: "用气量图例"
	//             },
	//             {
	//                 type: "ios-grid",
	//                 name: "pipeline",
	//                 text: "管道泄漏"
	//             },
	//             {
	//                 type: "ios-grid",
	//                 name: "eChart_test",
	//                 text: "测试图例"
	//             }
	//         ]
	//     },
	//     {
	//         text: "权限管理",
	//         type: "ios-paper",
	//         children: [
	//             {
	//                 type: "ios-grid",
	//                 name: "managep_permission",
	//                 text: "权限管理"
	//             }
	//         ]
	//     },
	//     {
	//         text: "生产管理",
	//         type: "ios-paper",
	//         children: [
	//             {
	//                 type: "ios-grid",
	//                 name: "meter_regist",
	//                 text: "设备批量注册"
	//             },
	//             {
	//                 type: "ios-grid",
	//                 name: "meter_export",
	//                 text: "基表信息导出"
	//             },
	//             {
	//                 type: "ios-grid",
	//                 name: "up_instructions_menu",
	//                 text: "查询上传指令"
	//             },
	//             {
	//                 type: "ios-grid",
	//                 name: "down_instructions_menu",
	//                 text: "查询下发指令"
	//             },
	//             {
	//                 type: "ios-grid",
	//                 name: "instructions_detailed_produce",
	//                 text: "设备交互(生产)"
	//             }
	//         ]
	//     }
	// ]

	// menuItems: [
	//   {
	//     name: "home", // 要跳转的路由名称 不是路径
	//     size: 18, // icon大小
	//     type: "md-home", // icon类型
	//     text: "主页" // 文本内容
	//   },
	//   {
	//     text: "生产管理",
	//     type: "ios-paper",
	//     children: [
	//       {
	//         type: "ios-grid",
	//         name: "meter_regist",
	//         text: "设备批量注册"
	//       },
	//       {
	//         type: "ios-grid",
	//         name: "meter_export",
	//         text: "基表信息导出"
	//       },
	//       {
	//         type: "ios-grid",
	//         name: "up_instructions_menu",
	//         text: "查询上传指令"
	//       },
	//       {
	//         type: "ios-grid",
	//         name: "down_instructions_menu",
	//         text: "查询下发指令"
	//       },
	//       {
	//         type: "ios-grid",
	//         name: "instructions_detailed_produce",
	//         text: "设备交互(生产)"
	//       }
	//     ]
	//   }
	// ]
	// menuItems: [
	//   {
	//     name: "home", // 要跳转的路由名称 不是路径
	//     size: 18, // icon大小
	//     type: "md-home", // icon类型
	//     text: "主页" // 文本内容
	//   },
	//   {
	//     text: "生产管理",
	//     type: "ios-paper",
	//     children: [
	//       {
	//         type: "ios-grid",
	//         name: "meter_regist",
	//         text: "设备批量注册"
	//       },
	//       {
	//         type: "ios-grid",
	//         name: "meter_export",
	//         text: "基表信息导出"
	//       },
	//       {
	//         type: "ios-grid",
	//         name: "up_instructions_menu",
	//         text: "查询上传指令"
	//       },
	//       {
	//         type: "ios-grid",
	//         name: "down_instructions_menu",
	//         text: "查询下发指令"
	//       },
	//       {
	//         type: "ios-grid",
	//         name: "instructions_detailed_produce",
	//         text: "设备交互(生产)"
	//       }
	//     ]
	//   }
	// ]
};

let hasMenus = false;
router.beforeEach(async (to, from, next) => {
	if (window.location.href.indexOf('/mobile') == -1) {
		if (localStorage.getItem("token") || /(iPhone|iPad|iPod|iOS|Android)/i.test(navigator.userAgent)) {
			if (to.path === "/login") {
				next({
					path: "/",
				});
			} else {
				if (hasMenus) {
					next();
				} else {
					try {
						//这里可以用 await 配合请求后台数据来生成路由
						// let menuObject = new Object(store.state.menuItems);
						console.log(menuOrigin.menuItems);
						let menu = genMenu(
							menuOrigin.menuItems,
							localStorage.getItem("permissions") || []
						);

						console.log(localStorage.getItem("permissions"));
						console.log(menu);
						store.state.menuItems = menu;

						// store.mutations.setMenu(store.state, menu);
						const routes = menusToRoutes(menuOrigin.menuItems);
						// 动态添加路由
						router.addRoutes(routes);
						hasMenus = true;

						next({
							path: to.path || "/",
						});
					} catch (error) {
						next(`/login?redirect=${to.path}`);
					}
				}
			}
		} else {
			hasMenus = false;
			if (to.path === "/login") {
				next();
			} else {
				next(`/login?redirect=${to.path}`);
			}
		}
	} else {
		if (/(iPhone|iPad|iPod|iOS|Android)/i.test(navigator.userAgent)) {
			if (localStorage.getItem("builder-token")) {
				if (to.path === "/mobile/builder_login") {
					next({
						path: "/mobile/builder/home",
					});
				} else if (to.path === "/mobile/customer_login") {
					next({
						path: "/mobile/customer/home",
					});
				} else {
					next();
				}
			} else {
				if (to.path === "/mobile/builder_login" || to.path === "/mobile/customer_login") {
					next();
				} else if (to.path === "/mobile/builder/home") {
					next(`/mobile/builder_login?redirect=${to.path}`);
				} else {
					next(`/mobile/builder_login`);
				}
			}
		}
	}

	// if ((!VueCookie.get('user') && !store.state.userInfo)) {
	//     // 第一次访问
	//     console.log('授权登录')
	//     // 跳转到微信授权页面，微信授权地址通过服务端获得
	//     axios.post('/api/login').then(res => {
	//         var data = res.data
	//         if (data.code === 100) {
	//             window.location.href = data.data
	//         }
	//     })
	// } else if (!store.state.userInfo) {
	//     // 刷新页面，获取数据存入vuex
	//     axios.get('/api/currentuser').then(res => {
	//         if (res.data.code === 100) {
	//             store.dispatch('setUserInfo', res.data.data)
	//             next()
	//         }
	//     })
	//     console.log('cookie生效期内登录')
	//     next()
	// } else {
	//     // 已经登录
	//     console.log('已登录')
	//     next()
	// }
});

router.afterEach((route) => {
	iView.LoadingBar.finish();
});

function genMenu(param, permissions) {
	let obj = JSON.parse(JSON.stringify(param));

	let param1 = param[1].children[6];
	console.log(1);
	console.log(param1);

	var resultArray = [];
	for (let i = 0; i < obj.length; i++) {
		let temp = obj[i];
		if (temp.name) {
			resultArray.push(temp);
		} else {
			if (temp.children) {
				let currentNode = temp;
				let newChildrenArray = [];
				let childrenArray = temp.children;
				for (let i = 0; i < childrenArray.length; i++) {
					if (permissions.indexOf(childrenArray[i].name) >= 0) {
						newChildrenArray.push(childrenArray[i]);
					}
				}

				if (newChildrenArray.length > 0) {
					currentNode.children = newChildrenArray;
					resultArray.push(currentNode);
				}
			}
		}
	}

	let param2 = param[1].children[6];
	console.log(2);
	console.log(param2);

	return resultArray;
}

function checkLoginStatus() {
	var result = true;
	var that = this;
	$.ajax({
		url: "/api/checkLoginStatus",
		contentType: "application/json",
		type: "get",
		success: function(data) {
			result = data.needLogin;

			if (result) {
				localStorage.setItem("token", "");
				localStorage.setItem("userImg", "");
				localStorage.setItem("permissions", "");
				localStorage.setItem("userName", "");
				localStorage.setItem("isAdmin", false);
				next(`/login?redirect=${to.path}`);
				alert("登录超时，请重新登录！");
			}
		},
		error: function(textStatus) {},
	});
}
